export default "__VITE_ASSET__a58289f5__"